<script setup lang="ts">
import type { PaginationDto, PaginationResponseDto } from "core/dto";

import type { GetAllUsersDto } from "~/common/interfaces/dto/users/get-all-users.dto";
import type { User } from "~/common/interfaces/entities/user.interface";

const dto: GetAllUsersDto & Partial<PaginationDto> = {
	isActive: true,
	limit: 5
};

const { data } = await useApiFetch<PaginationResponseDto<User>>("/users", { query: dto });
</script>

<template>
	<div class="sticky top-0 flex flex-col gap-y-4 h-screen w-[240px] p-4 bg-gray-0 border-r border-gray-200">
		<LayoutSideLogo />
		<LayoutSideNav />
		<LayoutSideTeam :users="data?.data" />
	</div>
</template>
